/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import levenshtein from 'fast-levenshtein';

export function spaceship(val1: any, val2: any) {
  if (val1 === null || val1 === undefined) {
    return 1;
  } if (val2 === null || val2 === undefined) {
    return -1;
  } if (typeof val1 !== typeof val2) {
    return 1;
  }

  // if(typeof val1 === 'boolean'){
  //   return (val1 === val2)? 0 : val1? -1 : 1;
  // }
  if (typeof val1 === 'string') {
    return val1.localeCompare(val2, undefined, { numeric: true });
  }
  if (val1 > val2) {
    return 1;
  } if (val1 < val2) {
    return -1;
  }
  return 0;
}

export function getObjectProperty(item: any, name: string): any {
  if (item === null || item === undefined) return undefined;
  const names = name.split('.');
  let value = item[names[0]];
  if (Array.isArray(value)) {
    if (names.length > 1) {
      // eslint-disable-next-line no-use-before-define
      return getArrayProperties(value, names[1]);
    }
    return value;
  }
  // eslint-disable-next-line no-plusplus
  for (let i = 1; i < names.length; i++) {
    if (value === null) return undefined;
    value = value[names[i]];
    if (Array.isArray(value)) {
      if (i < names.length - 1) {
        // eslint-disable-next-line no-use-before-define
        return getArrayProperties(value, names[i + 1]);
      }
      return value;
    }
  }
  return value;
}

function getArrayProperties(items: any[], name: string) {
  return items.map((item) => getObjectProperty(item, name));
}

/**
 * Factor for how much the levenshtein edit distance influences the result
 * Higher: Loose comparison.
 * Lower: Stricter comparison.
 */
const levenshteinCompensationFactor = 1;
/**
  * Factor for how much the substring position of the search-text in the text,
  * if present, influences result
  * Higher: Matters less.
  * Lower: Matters more.
  */
const positionCompensationFactor = 1.5;
/**
  * Factor for how much the length difference influences the result
  * Higher: Matters more.
  * Lower: Matters less.
  */
const lengthCompensationFactor = 0.3;
/**
  * Checks that a value matches an expected value
  * If the value is an array, it checks recursively against every item until a match is found
  */
const checkSearch = (
  expected: any,
  actual: any,
  ignoreLength: boolean,
): number | undefined => {
  try {
    // Check if the value is an array
    if (Array.isArray(actual)) {
      // Search through arrays
      for (const aIndex in actual) {
        const aValue = actual[aIndex];
        // Check if the array value matches the expected value
        const aResult = checkSearch(expected, aValue, ignoreLength);
        if (aResult !== undefined) {
          return aResult;
        }
      }
      return undefined;
    }

    if (typeof actual === 'number') actual = actual.toString();
    if (typeof expected === 'number') expected = expected.toString();
    if (typeof actual !== 'undefined' && actual !== null) {
      const actualText: string = actual.toLowerCase().replace(/\s+/g, '');
      const expectedText: string = expected.toLowerCase().replace(/\s+/g, '');

      if (!ignoreLength) {
        const lDistance = levenshtein.get(actualText, expectedText);
        const length = Math.abs(actualText.length - expectedText.length);
        let pos = actualText.indexOf(expectedText);
        if (pos === -1) {
          pos = expectedText.indexOf(actualText);
          if (pos === -1) pos = 10;
        }

        return ((lDistance / levenshteinCompensationFactor) - (length * lengthCompensationFactor)) + ((pos + 1) * positionCompensationFactor);
      }
      return levenshtein.get(actualText, expectedText);
    }
    return undefined;
  } catch (error) {
    console.error(error);
    return 0;
  }
};

export const basicSortCompare = (
  item1: any,
  item2: any,
  name: string,
): number | undefined => {
  const val1 = getObjectProperty(item1, name);
  const val2 = getObjectProperty(item2, name);
  if (val1 === undefined || val2 === undefined) return undefined;

  return spaceship(val1, val2);
};

/**
 * Performs a basic sorting compare with an optional fallback. Returns 0 if all cases fail
 * @param item1
 * @param item2
 * @param name
 * @param fallback
 */
export const basicSecSort = (
  item1: any,
  item2: any,
  name: string,
  fallback?: string,
): number => {
  try {
    const comp1 = basicSortCompare(item1, item2, name);
    if (fallback !== undefined && comp1 === undefined) {
      const comp2 = basicSortCompare(item1, item2, fallback);
      return comp2 || 0;
    }
    return comp1 || 0;
  } catch (error) {
    console.error(error);
    return 0;
  }
};

export const basicSearch = (
  item1: any,
  search: any,
  name: string,
  exact: boolean,
): number | undefined => {
  try {
    const val1 = getObjectProperty(item1, name);
    return checkSearch(search, val1, exact);
  } catch (error) {
    console.error(error);
    return 0;
  }
};

export const advancedSortCompare = <T>(item1: T, item2: T, type: keyof T) => {
  const val1 = item1[type];
  const val2 = item2[type];

  if (val1 === undefined || val2 === undefined) return undefined;
  return spaceship(val1, val2);
};

export const searchCompare = (expected: any, actual: any, exact: boolean) => checkSearch(expected, actual, exact);
export const advancedSearch = <T>(
  item1: T,
  search: any,
  type: keyof T,
  exact: boolean,
) => {
  try {
    const val1 = item1[type];
    return checkSearch(search, val1, exact);
  } catch (error) {
    console.error(error);
    return 0;
  }
};
export const advancedMultiSearch = <T>(
  item1: T,
  search: any,
  types: (keyof T)[],
  exact: boolean,
) => {
  let best = -1;
  for (const type of types) {
    const val = advancedSearch(item1, search, type, exact);
    if (val && val > best) best = val;
  }
  if (best === -1) return undefined;
  return best;
};

export const advancedSecSort = <T>(
  item1: T,
  item2: T,
  type: keyof T,
  fallback?: keyof T,
) => {
  try {
    const comp1 = advancedSortCompare(item1, item2, type);
    if (fallback !== undefined && comp1 === undefined) {
      const comp2 = advancedSortCompare(item1, item2, fallback);
      return comp2 || 0;
    }
    return comp1 || 0;
  } catch (error) {
    console.error(error);
    return 0;
  }
};

export const saveFile = (name: string, data: Blob) => {
  const a = document.createElement('a');
  // document.body.appendChild(a);
  const url = window.URL.createObjectURL(data);
  a.href = url;
  a.download = name;
  a.click();
  window.URL.revokeObjectURL(url);
  // setTimeout(() => {
  //   document.body.removeChild(a);
  // }, 0);
};
